const skillData = {
	skillList: [
		{
			label: "JAVA",
			detail: ["OOP특징과 데이터 탙입, 라이브러리를 이용하여 구현에 적용 가능합니다.", "메모리 구조를 이해하고 싱글톤디자인패턴을 통한 간단한 애플리케이션 제작하는 코딩이 가능합니다. ", "상속, 추상클래스를 활용한 기본적인 로직 구현이 가능합니다."],
			icon: "fab fa-java",
		},
		{
			label: "HTML/CSS",
			detail: ["원하는 UI를 실용적이고, 익숙하게 만들어 낼 수 있습니다.", "템플릿 엔진(node js)의 사용이 가능합니다.", "Css 최신 문법이 숙지되어 있고 Css 프리프로세서 Sass를 사용할 수 있습니다."],
			icon: "fab fa-html5",
		},
		{
			label: "jQuery",
			detail: ["다양한 속성과 메소드를 능숙하게 사용이 가능합니다.", "Ajax을 활용하여 비동기 통신으로 데이터 요청을 할 수 있습니다.", "jQuery UI 라이브러리를 활용할 수 있습니다."],
			icon: "fab fa-node-js",
		},
		{
			label: "Javascript/Typescript",
			detail: ["ES6와 이후의 자바스크립트 문법을 사용할 수 있습니다.", "Vanilla JS의 웹 제작이 가능하고 필요 이유에 대해 충분히 이해하고 있습니다.", "타입에 대한 이해를 하고 있고, 인터페이스의 사용이 가능합니다."],
			icon: "fab fa-js-square",
		},
		{
			label: "React",
			detail: ["컴포넌트 생명주기와 속성을 사용할 수 있습니다.", "class, function 컴포넌트의 차이를 이해하고 있으며 구분하여 사용할 수 있습니다.", "리덕스를 사용하여 상태관리를 할 수 있습니다."],
			icon: "fab fa-react",
		},
		{
			label: "Node.js",
			detail: ["Node.js가 작동하는 법에 대해 이해하고 있습니다.", "모델, 라우터, 컨트롤러, 서비스를 나누어 구조화된 서버를 만들 수 있습니다."],
			icon: "fab fa-node",
		},
		{
			label: "Git/Github",
			detail: ["git flow가 무엇인지 알고 있으며 왜 사용해야 하는지 이해하고 있습니다.", "깃과 깃헙을 사용하여 다른 개발자들과 협업을 할 수 있습니다.", "깃 리베이스를 할 수 있으며 스쿼시를 통한 커밋 관리 경험이 있습니다."],
			icon: "fab fa-git-square",
		},
		{
			label: "MongoDB",
			detail: ["MongoDB에서 API (CRUD) 가 무엇인지 알고 있으며 왜 사용해야 하는지 이해하고 있습니다.", "스키마 객체를 원하는 데이터 구조로 다룰 수 있으며 $match, $group, $sort, $limit 등과 같은 연산자를 사용하여 간단한 쿼리문으로 데이터를 가져올 수 있고, 프론트엔드 파트와 연결할 수 있습니다." ],
			icon: "fas solid fa-database",
		},
		{
			label: "OracleDB",
			detail: ["WHERE, GROUP BY, JOIN, ORDER BY 구문을 적절히 사용하여 원하는 조건에 맞게 데이터를 조회 할 수 있습니다", "서브쿼리 개념을 이해하고 있으며, 중첩된 질의를 실행할 수 있습니다.", "JDBC 드라이버를 이용해 ORACLE DB와 연결할 수 있고, CONNECTION 객체를 이용하여 연결을 관리할 수 있습니다.",
			"Statement 객체를 이용해 SQL 쿼리를 실행할 수 있고, 그 결과를 RESULT SET에 담아 데이터값을 조회할 수 있습니다."],
			icon: "fas solid fa-database",
		},
	],


	educationList: [
		{
			period: "2023.11 - ing",
			position: "온라인 부트캠프",
			company: "슈퍼코딩",
			explain: "JAVA, MYSQL, SPRING BOOT, DB 모델링 그룹 프로젝트 과정 커리큘럼에서 백엔드 웹사이트를 개발할 수 있는 지식들을 익혔습니다. ",
		},
	
		{
			period: "2023.06 - 2024.03",
			position: "온라인 부트캠프",
			company: "슈퍼코딩",
			explain: "HTML, JAVASCRIPT, REACT, NETLIFY, GITHUB, 3회에 거친 그룹 프로젝트 과정 커리큘럼에서 프론트엔드 웹사이트를 개발할 수 있는 지식들을 익혔습니다. ",
		},
		{
			period: "2023.01 - 2023.05",
			position: "오프라인 국비교육",
			company: "KH 정보교육원 당산지점",
			explain: "JAVA, HTML, JAVASCRIPT, ORACLE SQL 와 관련해 수강했습니다.",
		},
	],
};

export default skillData;


